import {
  POST_USERLIST,
  POST_USERLIST_SUCCESS,
  POST_USERLIST_ERROR,
} from '../../../constants/constantsRed';

export const postUserManagerRed = (
  state: any = false,
  actions: any
) => {
  switch (actions.type) {
    case POST_USERLIST:
      return {
        ...state,
        loading: true,
      };
    case POST_USERLIST_ERROR:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case POST_USERLIST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
